<template>
    <div class="row q-col-gutter-md q-pt-lg">
        <div class="col col-6">
            <q-list padding class="rounded-borders">
                <q-item-label header>{{$t('transfers.total_on_ramp_amounts')}}</q-item-label>

                <q-item v-for="item in onRamps" :key="item.currency">
                    <q-item-section avatar top>
                        <q-icon :name="item.country" size="md" />
                    </q-item-section>

                    <q-item-section>
                        <q-item-label lines="1">
                            <currency-format
                                class="text-bold inline-block"
                                :value="item.total"
                                :unit="item.symbol"
                                :decimal-max-length="4"
                                hide-white-spaces
                                hide-zero-decimal
                            />
                        </q-item-label>
                    </q-item-section>
                </q-item>
            </q-list>
        </div>
        <div class="col col-6">
            <q-list padding class="rounded-borders">
                <q-item-label header>{{$t('transfers.total_off_ramp_amounts')}}</q-item-label>

                <q-item v-for="item in offRamps" :key="item.currency">
                    <q-item-section avatar top>
                        <q-icon :name="item.country" size="md" />
                    </q-item-section>

                    <q-item-section>
                        <q-item-label lines="1">
                            <currency-format
                                class="text-bold inline-block"
                                :value="item.total"
                                :unit="item.symbol"
                                :decimal-max-length="4"
                                hide-white-spaces
                                hide-zero-decimal
                            />
                        </q-item-label>
                    </q-item-section>
                </q-item>
            </q-list>
        </div>
    </div>
</template>
<script>

export default {
    name: "TotalRampsAmounts",
    props: {
        onRamps: {
            type: Array,
            required: () => ([])
        },
        offRamps: {
            type: Array,
            default: () => ([])
        }
    },
    computed: {},
    data() {
        return {
            msg: 'TotalRampsAmounts'
        }
    },
}
</script>
<style>

</style>
